/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MessageSchedulePutRequestGeometry } from './MessageSchedulePutRequestGeometry';
import {
    MessageSchedulePutRequestGeometryFromJSON,
    MessageSchedulePutRequestGeometryFromJSONTyped,
    MessageSchedulePutRequestGeometryToJSON,
} from './MessageSchedulePutRequestGeometry';
import type { MessageSchedulePutRequestScheduleInner } from './MessageSchedulePutRequestScheduleInner';
import {
    MessageSchedulePutRequestScheduleInnerFromJSON,
    MessageSchedulePutRequestScheduleInnerFromJSONTyped,
    MessageSchedulePutRequestScheduleInnerToJSON,
} from './MessageSchedulePutRequestScheduleInner';

/**
 * 
 * @export
 * @interface MessageSchedulePutRequest
 */
export interface MessageSchedulePutRequest {
    /**
     * 
     * @type {boolean}
     * @memberof MessageSchedulePutRequest
     */
    addressed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MessageSchedulePutRequest
     */
    text?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MessageSchedulePutRequest
     */
    routing?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MessageSchedulePutRequest
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageSchedulePutRequest
     */
    senderMmsi?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MessageSchedulePutRequest
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MessageSchedulePutRequest
     */
    uid?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageSchedulePutRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof MessageSchedulePutRequest
     */
    noticeDescription?: number;
    /**
     * 
     * @type {number}
     * @memberof MessageSchedulePutRequest
     */
    broadcastInterval?: number;
    /**
     * 
     * @type {string}
     * @memberof MessageSchedulePutRequest
     */
    action?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageSchedulePutRequest
     */
    shapeuid?: string;
    /**
     * 
     * @type {MessageSchedulePutRequestGeometry}
     * @memberof MessageSchedulePutRequest
     */
    geometry?: MessageSchedulePutRequestGeometry;
    /**
     * 
     * @type {Array<MessageSchedulePutRequestScheduleInner>}
     * @memberof MessageSchedulePutRequest
     */
    schedule?: Array<MessageSchedulePutRequestScheduleInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MessageSchedulePutRequest
     */
    groups?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MessageSchedulePutRequest
     */
    schedMsgName?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageSchedulePutRequest
     */
    owner?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MessageSchedulePutRequest
     */
    safety?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MessageSchedulePutRequest
     */
    status?: string;
}

/**
 * Check if a given object implements the MessageSchedulePutRequest interface.
 */
export function instanceOfMessageSchedulePutRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MessageSchedulePutRequestFromJSON(json: any): MessageSchedulePutRequest {
    return MessageSchedulePutRequestFromJSONTyped(json, false);
}

export function MessageSchedulePutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageSchedulePutRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'addressed': !exists(json, 'addressed') ? undefined : json['addressed'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'routing': !exists(json, 'routing') ? undefined : json['routing'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'senderMmsi': !exists(json, 'sender_mmsi') ? undefined : json['sender_mmsi'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'noticeDescription': !exists(json, 'notice_description') ? undefined : json['notice_description'],
        'broadcastInterval': !exists(json, 'broadcast_interval') ? undefined : json['broadcast_interval'],
        'action': !exists(json, 'action') ? undefined : json['action'],
        'shapeuid': !exists(json, 'shapeuid') ? undefined : json['shapeuid'],
        'geometry': !exists(json, 'geometry') ? undefined : MessageSchedulePutRequestGeometryFromJSON(json['geometry']),
        'schedule': !exists(json, 'schedule') ? undefined : ((json['schedule'] as Array<any>).map(MessageSchedulePutRequestScheduleInnerFromJSON)),
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
        'schedMsgName': !exists(json, 'sched_msg_name') ? undefined : json['sched_msg_name'],
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'safety': !exists(json, 'safety') ? undefined : json['safety'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function MessageSchedulePutRequestToJSON(value?: MessageSchedulePutRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'addressed': value.addressed,
        'text': value.text,
        'routing': value.routing,
        'type': value.type,
        'sender_mmsi': value.senderMmsi,
        'enabled': value.enabled,
        'uid': value.uid,
        'description': value.description,
        'notice_description': value.noticeDescription,
        'broadcast_interval': value.broadcastInterval,
        'action': value.action,
        'shapeuid': value.shapeuid,
        'geometry': MessageSchedulePutRequestGeometryToJSON(value.geometry),
        'schedule': value.schedule === undefined ? undefined : ((value.schedule as Array<any>).map(MessageSchedulePutRequestScheduleInnerToJSON)),
        'groups': value.groups,
        'sched_msg_name': value.schedMsgName,
        'owner': value.owner,
        'safety': value.safety,
        'status': value.status,
    };
}

